/* sshpk/lib/index */ function _(require, module, exports) {
    // Copyright 2015 Joyent, Inc.
    var Key = require(344) /* ./key */;
    var Fingerprint = require(330) /* ./fingerprint */;
    var Signature = require(346) /* ./signature */;
    var PrivateKey = require(345) /* ./private-key */;
    var Certificate = require(326) /* ./certificate */;
    var Identity = require(342) /* ./identity */;
    var errs = require(329) /* ./errors */;
    module.exports = {
        /* top-level classes */
        Key: Key,
        parseKey: Key.parse,
        Fingerprint: Fingerprint,
        parseFingerprint: Fingerprint.parse,
        Signature: Signature,
        parseSignature: Signature.parse,
        PrivateKey: PrivateKey,
        parsePrivateKey: PrivateKey.parse,
        generatePrivateKey: PrivateKey.generate,
        Certificate: Certificate,
        parseCertificate: Certificate.parse,
        createSelfSignedCertificate: Certificate.createSelfSigned,
        createCertificate: Certificate.create,
        Identity: Identity,
        identityFromDN: Identity.parseDN,
        identityForHost: Identity.forHost,
        identityForUser: Identity.forUser,
        identityForEmail: Identity.forEmail,
        /* errors */
        FingerprintFormatError: errs.FingerprintFormatError,
        InvalidAlgorithmError: errs.InvalidAlgorithmError,
        KeyParseError: errs.KeyParseError,
        SignatureParseError: errs.SignatureParseError,
        KeyEncryptedError: errs.KeyEncryptedError,
        CertificateParseError: errs.CertificateParseError
    };
}
